import React from 'react';
import Icon from '../../../components/AppIcon';

const BugTrackerFilters = ({ filters, onFilterChange, onSearch, searchQuery }) => {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="relative">
        <Icon name="Search" size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          placeholder="Search issues..."
          value={searchQuery}
          onChange={(e) => onSearch(e?.target?.value)}
          className="pl-9 pr-4 py-2 text-sm border border-border rounded-lg bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/30 w-56"
        />
      </div>
      <select
        value={filters?.type}
        onChange={(e) => onFilterChange('type', e?.target?.value)}
        className="px-3 py-2 text-sm border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary/30"
      >
        <option value="all">All Types</option>
        <option value="bug">Bug</option>
        <option value="enhancement">Enhancement</option>
      </select>
      <select
        value={filters?.status}
        onChange={(e) => onFilterChange('status', e?.target?.value)}
        className="px-3 py-2 text-sm border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary/30"
      >
        <option value="all">All Statuses</option>
        <option value="open">Open</option>
        <option value="in_progress">In Progress</option>
        <option value="resolved">Resolved</option>
        <option value="closed">Closed</option>
      </select>
      <select
        value={filters?.priority}
        onChange={(e) => onFilterChange('priority', e?.target?.value)}
        className="px-3 py-2 text-sm border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary/30"
      >
        <option value="all">All Priorities</option>
        <option value="critical">Critical</option>
        <option value="high">High</option>
        <option value="medium">Medium</option>
        <option value="low">Low</option>
      </select>
    </div>
  );
};

export default BugTrackerFilters;
